import React from 'react';
import { NavLink } from 'react-router-dom';

function AdminPanel() {
    return (
        <div className="page admin-overview-page">
            <header className="page-header">
                <span className="page-eyebrow">Admin</span>
                <h1>Overview</h1>
                <p className="page-subtitle">Pick an area and work through checks without jumping between screens.</p>
            </header>

            <section className="admin-overview-grid">
                <article className="panel admin-panel-surface admin-overview-card">
                    <h2>Monetization</h2>
                    <p className="text-muted">Verify Monetag setup, trigger cooldowns, and no-ads bypass behavior.</p>
                    <NavLink to="/admin/monetization" className="btn btn-primary">Open monetization</NavLink>
                </article>
                <article className="panel admin-panel-surface admin-overview-card">
                    <h2>Users</h2>
                    <p className="text-muted">Review registered accounts, export user data, and manage admin access.</p>
                    <NavLink to="/admin/users" className="btn btn-primary">Open users</NavLink>
                </article>
                <article className="panel admin-panel-surface admin-overview-card">
                    <h2>Payments</h2>
                    <p className="text-muted">Inspect payment events and reconcile ad-removal purchases.</p>
                    <NavLink to="/admin/payments" className="btn btn-primary">Open payments</NavLink>
                </article>
            </section>

            <section className="panel admin-panel-surface mt-3">
                <h2 className="h5">Operational checklist</h2>
                <ul className="mb-0">
                    <li>Monetag verification meta present in index page.</li>
                    <li>Service worker file reachable at <code>/sw.js</code>.</li>
                    <li>No-ads purchase flow operational in profile payments.</li>
                    <li>Admin access controlled server-side via token/email/admin flag.</li>
                </ul>
            </section>
        </div>
    );
}

export default AdminPanel;
